import { Avatar, Box, Chip, Toolbar } from "@mui/material";
import { ChildCare } from "@mui/icons-material";
import Child from "components/Child";
import useChildren from "hooks/useChildren";
import React from "react";
import { useDispatch } from "react-redux";
import { selectChild } from "store/features/children";
import { stringAvatar } from "utils";
import { toAssetUrl } from "utils/apiConfig";

const Children: React.FC = () => {
  const { children = [], selected } = useChildren();
  const dispatch = useDispatch();

  return (
    <>
      <Toolbar
        sx={{
          bgcolor: "background.paper",
          borderBottom: 1,
          borderColor: "divider",
          py: 2,
          gap: 1.5,
        }}
      >
        <ChildCare sx={{ color: "text.secondary", fontSize: 20 }} />
        <Box display="flex" gap={1} flexWrap="wrap">
          {Array.isArray(children) &&
            children.map(({ firstName, lastName, photo }, index) => (
              <Chip
                key={index}
                avatar={
                  photo ? (
                    <Avatar src={toAssetUrl(photo as string)} />
                  ) : (
                    <Avatar
                      {...stringAvatar(`${firstName} ${lastName}`, {
                        width: 24,
                        height: 24,
                        fontSize: 11,
                      })}
                    />
                  )
                }
                label={`${firstName} ${lastName}`}
                onClick={() => dispatch(selectChild(index))}
                variant={selected === index ? "filled" : "outlined"}
                color={selected === index ? "primary" : "default"}
                sx={{
                  fontWeight: selected === index ? 600 : 400,
                  transition: "all 0.2s",
                  cursor: "pointer",
                }}
              />
            ))}
        </Box>
      </Toolbar>

      {selected !== undefined &&
        children.map((item, index) => (
          <Child key={index} item={item} value={selected} index={index} />
        ))}
    </>
  );
};

export default Children;
